import { Platform } from 'quasar'

export const mobileAppsMirrors = {
  mav: ['ogsmav.xyz'],
  map: ['ogsmap.xyz', 'f-dev-sport-f-webview-olimpnew-prod.olimp-casino.dev'],
}

export const defineApp = () => {
  let app
  Object.keys(mobileAppsMirrors).map((key) => {
    const isAppExist = mobileAppsMirrors[key].includes(location.host)
    if (isAppExist) {
      app = key
    }
    return false
  })
  return app
}

function emptyFunction() {}

export const getAppPostMessageFunction = () => {
  let method
  if (process.env.NODE_ENV === 'development' && process.env.WEBVIEW === '1') {
    return emptyFunction
  }
  if (Platform.is.ios) {
    method = window.webkit?.messageHandlers?.iosListener?.postMessage
    if (method) {
      method = method.bind(window.webkit.messageHandlers.iosListener)
    }
  } else if (Platform.is.android) {
    method = window.webInterface?.onMessage
    if (method) {
      method = method.bind(window.webInterface)
    }
  }

  if (!method) {
    return defineApp() ? emptyFunction : null
  }

  return method
}

export const postMessageFromWebviewToApp = (data) => {
  const method = getAppPostMessageFunction()
  // eslint-disable-next-line no-console
  console.log('postMessageFromWebviewToApp', data)

  const result = typeof data === 'string' ? data : JSON.stringify(data)
  try {
    if (typeof method === 'function') {
      return method(result)
    }
    return false
  } catch (e) {
    console.error('Method is not exist. Data: ', result)
    console.error(e)
    return false
  }
}

export const openLink = (url, type = null, history = false, linkInside = false) => {
  const nativeOpen = () => {
    if (history) {
      location.href = url
    } else {
      location.replace(url)
    }
  }

  return new Promise((resolve, reject) => {
    const method = getAppPostMessageFunction()
    if (!method) {
      nativeOpen()
      return resolve()
    }

    const typeOfMobileApp = defineApp()

    if (!typeOfMobileApp) {
      nativeOpen()
      return resolve()
    }

    try {
      if (typeOfMobileApp === 'mav') {
        if (linkInside) {
          postMessageFromWebviewToApp({ deeplink: `olympclub://linkInside?url=${url}` })
        } else {
          postMessageFromWebviewToApp({ deeplink: `olympclub://webview?url=${url}` })
        }

        postMessageFromWebviewToApp({ [type]: url })
        return resolve()
      }

      const resultFirst = postMessageFromWebviewToApp({ deeplink: `olympclub://webview?url=${url}` })

      if (type) {
        const resultSecond = postMessageFromWebviewToApp({ [type]: url })

        if (!resultFirst || !resultSecond) {
          return resolve()
        }
        nativeOpen()
        return resolve()
      }
      if (resultFirst) {
        nativeOpen()
        resolve()
      }
    } catch (e) {
      console.error(e)
      nativeOpen()
      return reject(e)
    }
  })
}

export function externalLinkMessageToApp(url) {
  const method = getAppPostMessageFunction()

  if (method === emptyFunction || method === null) {
    return (location.href = url)
  }

  if (Platform.is.android) {
    postMessageFromWebviewToApp({ type: 'openlink', data: url.toString() })
    postMessageFromWebviewToApp({ deeplink: `${process.env.DEEPLINK_ANDROID}://link?url=${url}` })
  } else {
    postMessageFromWebviewToApp({ deeplink: `${process.env.DEEPLINK_IOS}://link?url=${url}` })
  }
}
